<script lang="ts">
  import type { Picker } from "./types";
  import type { Unsubscriber } from "svelte/store";
  import { writable } from "svelte/store";
  import { DateTime } from "./lib/date-time";
  import { Calender } from "./lib/calender";
  import type { SelectionRange } from "./lib/range";
  import type { AvailabilityProvider, Availabilities } from "./availability/availability-provider";
  import { NoopAvailabilities, NoopAvailabilityProvider } from "./availability/noop-availability-provider";
  import DayPicker from "./Picker/DayPicker.svelte";
  import MonthPicker from "./Picker/MonthPicker.svelte";
  import YearPicker from "./Picker/YearPicker.svelte";
  import Loader from "./Loader.svelte";

  export let selection: SelectionRange;
  export let language: string;
  export let picker: Picker = "year";

  const provider: AvailabilityProvider = new NoopAvailabilityProvider();
  let availabilities = writable<Availabilities>(new NoopAvailabilities());

  let cancel: Unsubscriber = null;
  const calender = new Calender(language, function onCalenderLoad(from: DateTime, to: DateTime) {
    cancel?.call(null);
    cancel = provider.load(from, to).subscribe((_) => availabilities.set(_));
  });

  $: loading = provider.loading;
  $: selectionValue = selection.value;
  $: {
    const [from, to] = $selectionValue;
    if (from && !calender.isVisible(from.year, from.month)) {
      calender.show(from.year, from.month);
    }
  }

  const today = DateTime.today;
  calender.show(today.year, today.month);

  function select(year: number, month: number, nextMode: Picker) {
    picker = nextMode;
    calender.show(year, month);
  }
</script>

<div class="lrs-date-picker">
  <Loader loading={$loading} />

  {#if picker === "year"}
    <YearPicker year={calender.year} {language} on:select={(_) => select(_.detail, calender.month, "month")} />
  {:else if picker == "month"}
    <MonthPicker year={calender.year} month={calender.month} {language} on:select={(_) => select(_.detail.year, _.detail.month, "day")} on:back={(_) => (picker = "year")} />
  {:else}
    <DayPicker {selection} {calender} availabilities={$availabilities} {language} on:back={(_) => (picker = "month")} />
  {/if}
</div>

<style lang="scss" global>
  .lrs-date-picker {
    position: relative;
    display: inline-flex;
    user-select: none;
    box-sizing: border-box;
    background: #fff;
    font-size: 18px; // <- change this to change date-picker size!

    @media (max-width: 575px) {
      font-size: 14px;
    }

    *,
    *::before,
    *::after {
      box-sizing: inherit;
    }

    .lrs-loader {
      position: absolute;
      left: 0;
      right: 0;
    }
  }
</style>
